import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Layout Components
import AnnouncementBar from "./components/AnnouncementBar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Page Components
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Auth from "./pages/Auth";
import Wishlist from "./pages/Wishlist";
import Cart from "./pages/Cart";
import Shop from "./pages/Shop";
import Collections from "./pages/Collections"; // FIXED: Galat import (Contact) hata kar sahi import kar diya gaya hai
import BestSellers from "./pages/BestSellers";
import AboutCeliora from "./pages/About";
import ContactSection from "./pages/Contact";
import Orders from "./pages/Orders";
import NotFound from "./pages/NotFound";

// Optional Pages (Agar aapke paas created hain to uncomment kar lein)
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// import ProductDetails from "./pages/ProductDetails";

function App() {
  return (
    <BrowserRouter>
      <AnnouncementBar />
      <Navbar />

      <Routes>
        {/* Main Navigation Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/best-sellers" element={<BestSellers />} />

        {/* Collections Routing Fix */}
        <Route path="/collections" element={<Navigate to="/collections/serums" replace />} />
        <Route path="/collections/:category" element={<Collections />} />

        {/* User Account & Shopping Bag Routes */}
        <Route path="/profile" element={<Profile />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/about" element={<AboutCeliora />} />
        <Route path="/contact" element={<ContactSection />} />

        <Route path="*" element={<NotFound />} />

        {/* Dynamic Product Detail Route */}
        {/* <Route path="/product/:id" element={<ProductDetails />} /> */}
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;